'use client';

import { useDecisions } from '@libs/common-next';
import type { RelatedProductItem } from '@libs/common-types';
import { useRecommendedProducts, YmalProductsCarousel } from '@libs/shared-ui';

const PDP_YMAL_TITLE = 'You may also like';
const PDP_MIN_PRODUCTS = 3;

type YmalProductsCarouselWrapperProps = {
    products: RelatedProductItem[];
    productId?: string;
};

/**
 * PDP "You may also like" carousel.
 * When Optimizely `x_ymal_fbt` is on, shows FBT products for the PDP SKU;
 * otherwise shows related products.
 * Optimizely `mini_pdp` controls the quick-add CTA for eligible products.
 */
export function YmalProductsCarouselWrapper({ products, productId }: Readonly<YmalProductsCarouselWrapperProps>) {
    const isYmalRecommendationsEnabled = useDecisions('x_ymal_fbt');
    const isMiniPdpEnabled = useDecisions('mini_pdp');
    const recommendedProducts = useRecommendedProducts(
        isYmalRecommendationsEnabled,
        productId ? [productId] : undefined
    );
    const displayProducts = isYmalRecommendationsEnabled ? recommendedProducts : products;

    return (
        <YmalProductsCarousel
            products={displayProducts}
            title={PDP_YMAL_TITLE}
            minProducts={PDP_MIN_PRODUCTS}
            showQuickAdd={isMiniPdpEnabled}
        />
    );
}
